import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { ContentProvider } from './context/ContentContext';

// Home is the landing route — loaded eagerly so the very first paint on
// cheriyangroup.org has zero waterfall. Every other route is code-split so
// mobile visitors don't have to download the admin editor, the trials
// tables, the publications page etc. before they can read the home page.
import Home from './pages/Home';

const AboutPage              = lazy(() => import('./pages/AboutPage'));
const ResearchPage           = lazy(() => import('./pages/ResearchPage'));
const TrialsPage             = lazy(() => import('./pages/TrialsPage'));
const TeamPage               = lazy(() => import('./pages/TeamPage'));
const NewsPage               = lazy(() => import('./pages/NewsPage'));
const PublicationsPage       = lazy(() => import('./pages/PublicationsPage'));
const ContactPage            = lazy(() => import('./pages/ContactPage'));
const AdminPage              = lazy(() => import('./pages/AdminPage'));
const IgnitePage             = lazy(() => import('./pages/IgnitePage'));
const TrialsOfficePage       = lazy(() => import('./pages/TrialsOfficePage'));
const EchoPage               = lazy(() => import('./pages/EchoPage'));
const SheHealsPage           = lazy(() => import('./pages/SheHealsPage'));
const ResearchProceduresPage = lazy(() => import('./pages/ResearchProceduresPage'));
const TeamMemberPage         = lazy(() => import('./pages/TeamMemberPage'));
const NotFoundPage           = lazy(() => import('./pages/NotFoundPage'));

// Tiny inline fallback — deliberately branded and minimal so it appears
// for the ~200ms it takes to fetch a chunk without flashing an empty page.
function RouteFallback() {
  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#546072',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
        fontSize: 13,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
      }}
      data-testid="route-fallback"
    >
      Loading…
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/research" element={<ResearchPage />} />
              <Route path="/ignite" element={<IgnitePage />} />
              <Route path="/trials" element={<TrialsPage />} />
              <Route path="/trials-office" element={<TrialsOfficePage />} />
              <Route path="/echo" element={<EchoPage />} />
              <Route path="/she-heals" element={<SheHealsPage />} />
              <Route path="/research-procedures" element={<ResearchProceduresPage />} />
              <Route path="/team/:slug" element={<TeamMemberPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/publications" element={<PublicationsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/full-profile" element={<Navigate to="/about" replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
